// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__1klcJ","loader":"ContentLoader_loader__3_N0i","disabled":"ContentLoader_disabled__JiPGm"};